import api from './api';

// Roles constants for use across the app
export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ENTITY_ADMIN: 'ENTITY_ADMIN',
  CLIENT_ADMIN: 'CLIENT_ADMIN',
};

/**
 * Real API Login
 * POST /v1/auth/login
 */
export const loginAPI = async (email, password) => {
  try {
    const response = await api.post('/v1/auth/login', { 
      email, 
      password 
    });
    
    // Check for success based on your API structure
    if (response.data && response.data.success) {
      const { user, tokenData,permissions } = response.data.data;
      
      // 1. Set Access Token (Critical for API calls)
      if (tokenData && tokenData.accessToken) {
        localStorage.setItem('authToken', tokenData.accessToken);
      }
      
      // 2. Set User Details (For Dashboard Header)
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      }

      // 3. Set Permissions
      if(permissions){
        localStorage.setItem('permissions', JSON.stringify(permissions));
      }
      
      return response.data;
    } else {
      throw new Error(response.data?.message || 'Login failed.');
    }

  } catch (error) {
    // Return a readable error message
    const msg = error.response?.data?.message || error.message || 'Login failed. Please check your credentials.';
    throw msg;
  }
};

/**
 * Get currently logged in user from LocalStorage
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  return null;
};

/**
 * Logout function
 */
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  window.location.href = '/login'; // Hard redirect to clear state
};